import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from '@themes/colors';

export const CustomTextField = styled(TextField)(() => ({
  marginTop: '0',
  marginBottom: '0',
  width: '100%',
  '& .MuiOutlinedInput-root': {
    '&.Mui-disabled': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'transparent',
      },
      '.MuiOutlinedInput-input': {
        WebkitTextFillColor: colors.text.primary,
      },
    },
  },
  '& .MuiFormLabel-root.Mui-disabled': {
    color: colors.text.secondary,
    backgroundColor: 'transparent',
  },
  '& .Mui-disabled': {
    backgroundColor: colors.secondary.blueGrey,
    borderRadius: '4px',
  },
}));
